import React, { useContext, useState } from 'react'
import AuthContext from '../../context/auth/authContext'
import SubmitForm from './SubmitForm'
import Inputmask from 'inputmask'
import $ from 'jquery';
import toastr from 'toastr'
import validate from './validator';

function Step9() {
    setTimeout(() => {
        const arr = document.querySelectorAll('[data-inputmask]');
        Inputmask({ 'placeholder': '' }).mask(arr);
    }, 500);
    const authContext = useContext(AuthContext);
    let { lead, gotoNextStep, step, deleteKyc, lp } = authContext;
    const initialState = {
        kyc_license: '',
        kyc_license_label: 'Choose file',
        kyc_voided: '',
        kyc_voided_label: 'Choose file',
        kyc_businessLicense: '',
        kyc_businessLicense_label: 'Choose file',

    }
    let $needsBusinessLicense = false;
    lp.products.forEach((item) => {
        let $match = item.types.find(x => x.id === lead.offer.product_type_id);
        if ($match) {
            $needsBusinessLicense = $match.name == 'lease' ? 1 : 0;
        }
    });
    $needsBusinessLicense = 0; // disabled temporarly
    const [fields, setFields] = useState(initialState);
    const handleChange = (event) => {
        const target = event.target;
        let files = target.files;
        let index = target.name;
        let $file = null;
        $.each(files, (i, file) => {
            var $result = validate(index, file);
            if ($result) {
                toastr.error($result, 'Error ...');
            } else {
                $file = file;
            }
        });
        $(`input[name="${index}"]`).removeClass('is-invalid');
        setFields({
            ...fields,
            [index + '_label']: $file ? ($file.name.length > 40 ? $file.name.substring(0, 40 - 3) + "..." : $file.name) : 'Choose file',
            [index]: $file
        });
    }
    const handleSubmit = (event) => {
        event.preventDefault();
        let $err = 0;
        $('input[name="kyc_license"], input[name="kyc_voided"], input[name="kyc_businessLicense"]').removeClass('is-invalid');
        if (!fields.kyc_voided && !lead.files.find((x) => x.type == 'kyc_voided')) {
            toastr.error('Please select your voided Business Check!', 'Error...');
            $('input[name="kyc_voided"]').addClass('is-invalid');
            $err++;
        }
        if (!fields.kyc_license && !lead.files.find((x) => x.type == 'kyc_license')) {
            toastr.error('Please select your driver\'s license !', 'Error...');
            $('input[name="kyc_license"]').addClass('is-invalid');
            $err++;
        }
        if (!fields.kyc_businessLicense && !lead.files.find((x) => x.type == 'kyc_businessLicense') && $needsBusinessLicense == 1) {
            toastr.error('Please select your business license !', 'Error...');
            $('input[name="kyc_businessLicense"]').addClass('is-invalid');
            $err++;
        }
        if ($err === 0)
            gotoNextStep(fields, step);

    }
    const skipStep = (e) => {
        e.preventDefault();
        gotoNextStep(fields, step);
    }
    const deleteKycDocument = ($id) => {
        deleteKyc($id);
    }
    return (
        <>
            <form onSubmit={e => handleSubmit(e)}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="">Driver License or State ID</label>
                                                <div className="input-group">
                                                    <div className="custom-file">
                                                        <input type="file" name="kyc_license" accept="capture=camera;,.pdf,.png,.jpg" onChange={e => handleChange(e)}
                                                            className="custom-file-input" />
                                                        <label className="custom-file-label">{fields.kyc_license_label}</label>
                                                    </div>
                                                </div>
                                                <p className="small text-muted mt-1 mb-0">(Files cannot exceed 25Mb)</p>

                                            </div>
                                            {lead.files.map((file, i) => {
                                                return (
                                                    <div key={file.id}>
                                                        {file.type === 'kyc_license' ?
                                                            <span >
                                                                <small > {file.name.substr(11, 80)}</small>
                                                                <button className="btn btn-sm trash_button" type="button" title="Delete this file" onClick={() => deleteKycDocument(file.id)}><i className="fas fa-trash-alt"></i></button>
                                                            </span>
                                                            : ''
                                                        }
                                                    </div>
                                                )
                                            })}

                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="">Image of Voided Business Check</label>
                                                <div className="input-group">
                                                    <div className="custom-file">
                                                        <input type="file" accept="capture=camera;,.pdf,.png,.jpg" name="kyc_voided" onChange={e => handleChange(e)}
                                                            className="custom-file-input" />
                                                        <label className="custom-file-label">{fields.kyc_voided_label}</label>
                                                    </div>
                                                </div>
                                                <p className="small text-muted mt-1 mb-0">(Bank letter also acceptable)</p>
                                            </div>
                                            {lead.files.map((file, i) => {
                                                return (
                                                    <div key={file.id}>
                                                        {file.type === 'kyc_voided' ?
                                                            <span>
                                                                <small > {file.name.substr(11, 80)}</small>
                                                                <button className="btn btn-sm trash_button" type="button" title="Delete this file" onClick={() => deleteKycDocument(file.id)}><i className="fas fa-trash-alt"></i></button>
                                                            </span>
                                                            : ''
                                                        }
                                                    </div>
                                                )
                                            })}
                                        </div>
                                        {$needsBusinessLicense == 1 ?
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="">Image of Business License</label>
                                                    <div className="input-group">
                                                        <div className="custom-file">
                                                            <input type="file" accept="capture=camera;,.pdf,.png,.jpg" name="kyc_businessLicense" onChange={e => handleChange(e)}
                                                                className="custom-file-input" />
                                                            <label className="custom-file-label">{fields.kyc_businessLicense_label}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                {lead.files.map((file, i) => {
                                                    return (
                                                        <div key={file.id}>
                                                            {file.type === 'kyc_businessLicense' ?
                                                                <span>
                                                                    <small > {file.name.substr(11, 80)}</small>
                                                                    <button className="btn btn-sm trash_button" type="button" title="Delete this file" onClick={() => deleteKycDocument(file.id)}><i className="fas fa-trash-alt"></i></button>
                                                                </span>
                                                                : ''
                                                            }
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                            : ''}
                                    </div>
                                    <p className="text-muted text-center mt-3 skip">You can <a href="/" onClick={(e) => skipStep(e)}>SKIP</a> this step for now and upload it later!</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <SubmitForm />
                </div >
            </form >
        </>
    )
}

export default Step9
